import React from "react";
import { useEffect, useState } from 'react';
import { clone } from 'lodash';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Element from "../InvoiceElement";
import { invoiceFields } from '../InvoiceModel';
import CustomInputValid from "../../../components/CustomInput/CustomInputValid";
import { INVOICE_STATUS } from "../InvoiceObj";
import CustomDate from "../../../components/CustomDate/CustomDate";
import Button from "../../../components/CustomButtons/Button";
import { cloneJ, handleError } from "../../../shared/utility";
import axios from "store/axios/axios-invoice";
import Notification from "../../../components/Notification/Notification";

export const invoiceFormInfoFields = ["date", "title", "illi", "invoice"];

const InvoiceFormInfo = (props) => {
    const { formData, setFormData, updateDataObj } = props;
    const [currentDate, setCurrentDate] = useState('');
    const [currentNotes, setCurrentNotes] = useState('');
    const [notification, setNotification] = useState('');
    console.log('permissions', props.permissions);

    useEffect(() => {
        const newFormData = clone(formData);
        if (!newFormData.invoice) {
            newFormData.invoice = '001';
            setFormData(newFormData);
        }
        setCurrentDate(formData.date);
        setCurrentNotes(formData.notes || '');
    }, [])

    const renderElement = (field, access) => {
        return (
            <Element
                updateDataObj={updateDataObj}
                fieldModels={invoiceFields}
                data={formData}
                setData={setFormData}
                field={field}
                access={access}
                permissions={props.permissions}
            />
        );
    };
    const renderFields = () => {
        return invoiceFormInfoFields.map((field, index) => {
            console.log('fff', field, props);
            const approved_already = props.parentData?.status === INVOICE_STATUS.APPROVED ? true : false;
            if (field === 'date' && currentDate &&
                approved_already &&
                props.action === 'Edit' && props.permissions.indexOf('approve') !== -1) {
                return <>
                    <CustomDate
                        value={currentDate}
                        onChange={(d) => {
                            setCurrentDate(d);
                        }}
                    />
                </>
            }
            if (field !== 'invoice') {
                return <div className={props.parentData?.status === INVOICE_STATUS.APPROVED ? `no-click gray-bg` : ``}>
                    <React.Fragment key={`invoiceField-${index}`}>
                        {renderElement(field)}
                    </React.Fragment>
                </div>
            }
            return null;
        });
    };

    return (
        <div
            style={{padding:20}}
        >
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <hr />
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                    {renderFields()}
                    {/* <CustomInputValid
                        label="Invoice Number"
                        value={props.parentData?.invoice_num}
                        onChange={(e) => {
                            const newFormData = clone(props.parentData);
                            newFormData.invoice_num = e.target.value;
                            props.setParentData(newFormData);
                        }}
                        disabled={props.parentData?.status === INVOICE_STATUS.APPROVED ? true : false}
                    /> */}
                    {<Notification
                        open={notification ? true : false}
                        close={() => {
                            setNotification('');
                        }}
                        message={notification}
                    />}
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                    <CustomInputValid
                        label="Notes"
                        value={currentNotes}
                        onChange={(e) => {
                            setCurrentNotes(e.target.value);
                            updateDataObj('notes', e.target.value);
                        }}
                        multiline
                        rowsMax="6"
                    />
                    {props.action === 'Edit' && props.parentData?.id && <Button
                        color="rose"
                        onClick={async () => {
                            const parentData = props.parentData;
                            const newFormData = cloneJ(formData);
                            newFormData.date = currentDate;
                            newFormData.notes = currentNotes;
                            const datObj = {
                                id: parentData.id,
                                data: JSON.stringify(newFormData)
                            };
                            try {
                                await axios.put('/entry', datObj);
                                updateDataObj('date', currentDate);
                                updateDataObj('notes', currentNotes);
                                setNotification('Saved');
                            } catch (e) {
                                handleError(e);
                                alert('Error saving.');
                            }
                        }}
                    >SAVE</Button>}
                </GridItem>
            </GridContainer>
        </div>
    );
};

export default InvoiceFormInfo;
